import React from "react";
import "./ContentImageSection.scss";

const ContentImageSection = ({
  title,
  description,
  image,
  highlightWords = [],
  reverse = false,
}) => {
  const renderDescription = () => {
    let text = description;

    highlightWords.forEach((word) => {
      const regex = new RegExp(`(${word})`, "gi");
      text = text.replace(regex, `<span class="highlight">$1</span>`);
    });

    return { __html: text };
  };

  return (
    <section
      className={`content-image-section ${reverse ? "reverse" : ""}`}
    >
      <div className="content-image-section__content">
        <h2>{title}</h2>
        <p dangerouslySetInnerHTML={renderDescription()} />
      </div>

      <div className="content-image-section__image">
        <img src={image} alt={title} />
      </div>
    </section>
  );
};

export default ContentImageSection;
